import { toPrecisionRoundedDown } from '@banking/ui/utils/to-precision-rounded-down';
import { toFixedRoundedDown } from '@banking/ui/utils/to-fixed-rounded-down';
import { SATOSHI_ABBREVIATION_THRESHOLD, BITCOIN_TO_SATOSHI } from '@banking/ui/utils/constants';

// NOTE(dhuxley): 'sat' or 'sats' is the common suffix of satoshis, but it varies
// based on singular or plural, which is not known when building the formatter.
// So, the caller of this formatter builder will need to set `sat` or `sats` if desired.
export function formatSatoshis(formatter, intl, amount, shouldUseAbbreviation) {
  const shouldUseSingular = amount === 1 && !shouldUseAbbreviation;
  const suffix = shouldUseSingular && ` ${intl.t('banking.investments.formatter.satoshi')}` || shouldUseAbbreviation && `M ${intl.t('banking.investments.formatter.satoshis')}` || ` ${intl.t('banking.investments.formatter.satoshis')}`;
  formatter.setPositiveSuffix(suffix).setNegativeSuffix(suffix);
}

// NOTE: manipulate the amount directly(eg. set precision, round down/up, shrink for abbreviation, etc.)
// this can be potentially moved to field-kit
/**
 *
 * @param {
 *  amount: the amount of bitcoin in sats unit. It's always an integer.
 *  currencyCode: has to be 'BTC'.
 *  shouldUseAbbreviation: if the sats value needs abbreviation.
 *  formatAsCents: if the intention is to format as satoshi or BTC
 * }
 * @returns formatted amount in sats
 */
export function formatBitcoinAmount({
  amount,
  currencyCode,
  shouldUseAbbreviation,
  formatAsCents
}) {
  let formattedAmount = amount;
  if (currencyCode === 'BTC') {
    // Abbreviate sats if it's more than 1 million sats
    // e.g. 3_450_000 sats is formated to 3.4M sats
    if (formatAsCents && shouldUseAbbreviation) {
      formattedAmount = amount / SATOSHI_ABBREVIATION_THRESHOLD;
      formattedAmount = Number(toFixedRoundedDown(formattedAmount, 1));
    }

    // for < 1 BTC, keep two precision digits
    // e.g. 234_000 sats (aka 0.00234 BTC) is formated to 230_000 sats (aka 0.0023 BTC)
    if (!formatAsCents && amount < BITCOIN_TO_SATOSHI) {
      // can't use `amount.toPrecision(2)` as it rounds up 0.109BTC to 0.11BTC
      formattedAmount = Number(toPrecisionRoundedDown(amount, 2));
    }

    // for >=1 BTC, keep (max) two decimal digits
    // e.g. 134_500_000 sats (aka 1.345 BTC) is formated to 134_000_000 sats (aka 1.34 BTC)
    if (!formatAsCents && amount >= BITCOIN_TO_SATOSHI) {
      // convert to 1.345 (as in BTC) first
      formattedAmount = amount / BITCOIN_TO_SATOSHI;
      // round down to two precision digts then convert back to 134_000_000 (as in sats)
      formattedAmount = Number(toFixedRoundedDown(formattedAmount, 2)) * BITCOIN_TO_SATOSHI;
    }
  }
  return formattedAmount;
}